const SurCharge = {
  specialHolidays: 'specialHolidays',
  regularHolidays: 'regularHolidays',
  sunday: 'sunday',
  nightShift: 'nightShift',
  lateShift: 'lateShift',
}

export default SurCharge
